import { Country, City, ICountry, ICity } from 'country-state-city';

export interface CountryOption {
  value: string;
  label: string;
  isoCode: string;
}

export interface CityOption {
  value: string;
  label: string;
  stateCode?: string;
}

export function getCountryOptions(): CountryOption[] {
  return Country.getAllCountries().map((c: ICountry) => ({
    value: c.name,
    label: c.name,
    isoCode: c.isoCode,
  }));
}

export function getCityOptions(countryCode: string): CityOption[] {
  return City.getCitiesOfCountry(countryCode)?.map((c: ICity) => ({
    value: c.name,
    label: c.stateCode ? `${c.name}, ${c.stateCode}` : c.name,
    stateCode: c.stateCode,
  })) || [];
}

export function getCountryByName(name: string): ICountry | undefined {
  return Country.getAllCountries().find(c => c.name === name);
}

export function buildLocationString(city: string, country: string): string {
  return `${city}, ${country}`;
}

// Backward-compatible: kept for any code still referencing WORLD_CITIES
export const WORLD_CITIES = Country.getAllCountries().flatMap((country: ICountry) =>
  (City.getCitiesOfCountry(country.isoCode) || []).map((city: ICity) => ({
    value: `${city.name}, ${country.name}`,
    label: `${city.name}, ${country.name}`,
    country: country.name,
  }))
);
